export default "__VITE_ASSET__BYGJniyg__"